"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.31 8.8a1.55 1.55 0 0 0-1.44-1h-6.21l-2.23-6.3a1.53 1.53 0 0 0-2.87 0L8.34 7.79H2.13a1.53 1.53 0 0 0-1 2.71l5.27 4.36-2.2 6.62a1.53 1.53 0 0 0 2.36 1.72l5.44-4 5.44 4a1.53 1.53 0 0 0 2.36-1.72l-2.21-6.62 5.28-4.37a1.54 1.54 0 0 0 .44-1.69Zm-7.6 4.91a1 1 0 0 0-.32 1.13L17 19.7a.25.25 0 0 1-.09.29.26.26 0 0 1-.31 0l-4-2.92a1.09 1.09 0 0 0-.62-.2 1.07 1.07 0 0 0-.62.2L7.4 20a.26.26 0 0 1-.31 0 .25.25 0 0 1-.09-.3l1.61-4.86a1 1 0 0 0-.32-1.13l-4-3.36a.25.25 0 0 1-.08-.29.26.26 0 0 1 .24-.18h4.63a1.05 1.05 0 0 0 1-.69l1.68-4.78a.27.27 0 0 1 .5 0l1.68 4.78a1.05 1.05 0 0 0 1 .69h4.67a.27.27 0 0 1 .25.18.25.25 0 0 1-.08.29Z"
}), 'RatingStar');

exports.default = _default;